import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { useLocation } from "@reach/router";

import endurance from '../../images/misc/endurance-white.png'
import { DesktopNav } from './desktopNav';
import { MobileNav } from './mobileNav';

function Header() {
  const [isExpanded, toggleExpansion] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hovered, setHovered] = useState(null);

  // Track active page
  const location = useLocation();

  // Used for active page underline
  const isCurrent = (route) => {
    if (route === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(route);
  };

  // listen for scroll
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 5);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div className={`sticky top-0 z-50 bg-blueGray-700 transition-all duration-300
          ${scrolled
          ? "backdrop-blur-md bg-opacity-90 shadow-lg"
          : "bg-blueGray-700"
        }
        `}>
        <header>
          <div className="flex flex-wrap items-center justify-between px-10 py-4 mx-auto">
            <Link to="/" className="flex gap-6">
              <img src={endurance} alt="" className="w-16 cursor-pointer">
              </img>
              <div>
                <h1 className="text-3xl font-medium text-white">Jason Cho</h1>
                <h2 className="text-lg text-gray-300">3D Rigging Artist</h2>
              </div>
            </Link>

            {/* Navs */}
            <DesktopNav
              navLinks={navLinks}
              hovered={hovered}
              setHovered={setHovered}
              isCurrent={isCurrent}
            />
            <button
              onClick={() => toggleExpansion(!isExpanded)}
              className="px-3 py-2 text-white border border-white rounded md:hidden"
            >
              ☰
            </button>
          </div>
        </header>

        <MobileNav
          navLinks={navLinks}
          isExpanded={isExpanded}
          toggleExpansion={toggleExpansion}
          isCurrent={isCurrent}
        />
      </div>
      {isExpanded && (
        <div
          className="fixed inset-0 bg-black/40 z-40"
          onClick={() => toggleExpansion(false)}
        />
      )}
    </>
  );
}

const navLinks = [
  {
    route: `/`,
    title: `Work`,
  },
  {
    route: `/reel`,
    title: `Reel`,
  },
  {
    route: `/about`,
    title: `About`,
  },
]

export default Header;
